<template>
  <div class="footer-container">
    <unicom-linha :espacamento="false">
      <unicom-coluna
        sm="11"
        :style="$breakpoint.smAndDown ? 'max-width: 85%' : 'max-width: 90%'"
        alinhamento="end"
      >
        <unicom-area-texto
          @tecla-pressionada="teclaPressionada"
          title="Digite uma nova observação"
          max="350"
          colorOnFocus="#00995D"
          mostrarContador
          alturaAutomatica
          :textAreaStyleProp="{
            padding: '10px',
            'font-size': '16px',
            'line-height': '16px',
            'max-height': '100px'
          }"
          placeholder="Digite uma nova observação..."
          v-model="observacao"
          prevenirEnter
          ref="area-texto"
          spellcheck
          @altura-textarea="alturaTextArea"
        />
      </unicom-coluna>
      <unicom-coluna sm="auto" alinhamento="end" class="ml-auto">
        <unicom-linha :style="`height: ${alturaTextAreaComputed}px`">
          <unicom-coluna
            sm="auto"
            alinhamento="start"
            @click="salvarObservacao"
          >
            <unicom-icone
              class="icone-send"
              :class="{ desativado: enviarDesativado }"
              nome="send"
              :tamanho="20"
              :tooltipNome="enviarDesativado ? '' : 'Enviar'"
              localizacaoTooltip="top"
            />
          </unicom-coluna>
        </unicom-linha>
      </unicom-coluna>
    </unicom-linha>
  </div>
</template>

<script>
export default {
  data() {
    return {
      observacao: "",
      objetosTeclas: {
        Enter: () => {
          this.salvarObservacao();
        }
      },
      alturaComponente: 0
    };
  },
  mounted() {
    // Força o calcula de altura
    this.$nextTick(() => {
      this.$refs["area-texto"].calcularAlturaAutomatica();
    });
  },
  methods: {
    salvarObservacao() {
      if (this.enviarDesativado) return;

      this.$store.dispatch("salvarObservacao", {
        observacao: this.observacao,
        callback: () => this.$emit("subir-scroll")
      });

      this.observacao = "";

      // Força o calcula de altura
      this.$nextTick(() => {
        this.$refs["area-texto"].calcularAlturaAutomatica();
      });
    },
    focusInput() {
      setTimeout(() => {
        this.$refs["area-texto"].$refs["textarea"].focus();
      }, 10);
    },
    /**
     * @param {KeyboardEvent} event
     */
    teclaPressionada(event) {
      const tecla = event.code || event.key;

      if (!Object.keys(this.objetosTeclas).includes(tecla)) return;
      if (event.shiftKey && tecla === "Enter") return;

      this.objetosTeclas[tecla]();
    },
    alturaTextArea(altura) {
      this.alturaComponente = altura;

      this.$emit("altura-text-area", altura + 32);
    }
  },
  computed: {
    alturaTextAreaComputed() {
      return this.alturaComponente + 2;
    },
    enviarDesativado() {
      return this.observacao.length <= 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.footer-container {
  height: 100%;
  padding: 40px 32px;
  box-shadow: 0px -5px 10px #0000001a;
}

.icone-send {
  color: white;
  background: #00995d;
  border-radius: 5px;
  height: 22px;
  width: 22px;
  padding: 8px;
  cursor: pointer;

  &.desativado {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
</style>
